import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    (async () => {
      try {
        const hash = window.location.hash || "";
        const params = new URLSearchParams(hash.replace(/^#/, ""));
        const session_id = params.get("session_id");
        if (!session_id) {
          navigate("/", { replace: true });
          return;
        }
        const { data } = await api.post("/auth/session", { session_id });
        if (data.session_token) {
          localStorage.setItem("session_token", data.session_token);
        }
        // Cache user synchronously so a subsequent offline reload keeps them signed in
        try { localStorage.setItem("vv_user", JSON.stringify(data.user)); } catch (_) { /* ignore */ }
        setUser(data.user);
        navigate("/dashboard", { replace: true, state: { user: data.user } });
      } catch (e) {
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="brutal-card p-8">
        <div className="font-mono uppercase tracking-widest text-sm">Signing you in…</div>
      </div>
    </div>
  );
}
